// extracted by mini-css-extract-plugin
export default {"body":"SVCManageHistory_body__pMm8Z","fileuploadHistory":"SVCManageHistory_fileuploadHistory__sA-S3","heading":"SVCManageHistory_heading__0QzNe"};